<template>
  <div class="ui-text-input-dropdown">
    <v-select v-bind="attrs" class="text-input" v-on="$listeners">
      <template slot="no-options"> Элементов для выбора нет </template>
    </v-select>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

export default {
  data() {
    return {
      pluginAttrs: {
        filterable: false,
        components: {
          OpenIndicator: {
            render: (createElement) => createElement(),
          },
        },
      },
    }
  },
  computed: {
    attrs() {
      return Object.assign({}, this.$attrs, this.pluginAttrs)
    },
  },
  methods: {},
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';

// stylelint-disable
.ui-text-input-dropdown {
  .vs--open,
  .vs--loading {
    .vs__selected {
      opacity: 0 !important;
    }
  }

  .text-input {
    width: 100%;

    .vs__actions {
      padding: 0px 0px 0 3px;
    }

    .vs__search {
      margin: 0;
      padding: 0;
      background-color: $input-background;
    }

    .vs__selected {
      margin: 0 0 -2px 0;
      padding: 0;
      overflow: hidden;
      word-break: break-all;
      height: 21px;
      display: block;
      position: absolute;
      z-index: 2;

      &-options {
        padding: 0;
      }
    }

    .vs__spinner {
      width: 1rem;
      height: 1rem;

      border: 1px solid $color-gray-50;
      border-left: 1px solid $primary;
    }

    .vs__search::placeholder,
    .vs__dropdown-toggle {
      color: $color-font-placeholder;
      background: $input-background;
      border: none;
    }

    .vs__clear,
    .vs__open-indicator {
      fill: $color-font-placeholder;
      margin: 0;
    }
    .vs__dropdown {
      &-menu {
        border: none;
        background: $white;
        color: $color-font-placeholder;
        padding: rem(8px) 0 !important;
      }

      &-option {
        padding: 8px 20px;
        overflow: hidden;

        &--highlight {
          color: $color-gray-600;
          background: #f5f9fd;
        }
      }

      &-toggle {
        width: 100%;
        padding: 0.735rem rem(16px);
        font-family: 'SF Pro Text', Lato, Helvetica, Arial, sans-serif;
        font-size: rem(12px);
        color: $color-gray-600;
        background-color: $input-background;
        border: 1px solid transparent;
        border-right: 0;
        border-left: 0;
        outline: none;
        box-shadow: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.ui-text-input-dropdown {
  position: relative;

  @include createFlex(flexbox, nowrap, row, flex-start, center, center);
}
</style>
